'use client';

import { cn } from '@coas/ui/lib';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import IconArrowLeft from '~/shared/assets/icons/arrow-left.svg';
import type { PropsOf } from '~/shared/lib';

type TelegramBackButtonProps = Omit<PropsOf<'button'>, 'type' | 'onClick' | 'children'>;

const useIsTelegramWebApp = () => {
    const [isMounted, setIsMounted] = useState(false);
    const [isTelegramWebApp, setIsTelegramWebApp] = useState(false);

    useEffect(() => {
        if (!isMounted) return setIsMounted(true);

        // @ts-expect-error
        setIsTelegramWebApp(typeof TelegramWebviewProxy !== 'undefined');
    }, [isMounted]);

    return isTelegramWebApp;
};

const TelegramBackButton: React.FC<TelegramBackButtonProps> = ({ className, ...props }) => {
    const router = useRouter();
    const pathname = usePathname();

    const isTelegramWebApp = useIsTelegramWebApp();

    if (!isTelegramWebApp || pathname === '/') return null;

    return (
        <button type={'button'} onClick={() => router.back()} className={cn('aspect-square', className)} {...props}>
            <IconArrowLeft className={'size-full stroke-neutral-50'} />
        </button>
    );
};
TelegramBackButton.displayName = 'TelegramBackButton';

export default TelegramBackButton;
